/** "1,2" formátumú pályarész-CSV feldolgozása; null = teljes pálya */
export const parseVenueSections = (csv?: string | null): number[] | null => {
  if (!csv) return null;
  const parts = csv
    .split(',')
    .map((s) => parseInt(s.trim(), 10))
    .filter((n) => Number.isFinite(n) && n >= 1);
  return parts.length > 0 ? Array.from(new Set(parts)).sort((a, b) => a - b) : null;
};

/** Egy pályarész neve: ha elnevezték, a név, különben "2. rész". */
export const sectionLabel = (section: number, names?: string[] | null): string =>
  names?.[section - 1]?.trim() || `${section}. rész`;

/** Több rész felirata: elnevezett részeknél vesszővel a nevek, különben "1., 2. rész". */
export const sectionsLabel = (sections: number[], names?: string[] | null): string => {
  const sorted = [...sections].sort((a, b) => a - b);
  if (sorted.some((s) => names?.[s - 1]?.trim())) {
    return sorted.map((s) => sectionLabel(s, names)).join(', ');
  }
  return `${sorted.join('., ')}. rész`;
};

/** Rövid magyar felirat a foglalt pályarészekhez, pl. "1., 2. rész" vagy a részek neve */
export const formatVenueSections = (csv?: string | null, names?: string[] | null): string | null => {
  const sections = parseVenueSections(csv);
  if (!sections) return null;
  return sectionsLabel(sections, names);
};

/** A kijelölés aránya alapján: Egész / Fél / Negyed pálya felirat */
export const describeSelection = (selected: number[], sectionCount: number, names?: string[] | null): string => {
  if (sectionCount <= 1 || selected.length === 0 || selected.length >= sectionCount) {
    return 'Egész pálya';
  }
  const ratio = selected.length / sectionCount;
  const parts = sectionsLabel(selected, names);
  if (ratio === 0.5) return `Fél pálya (${parts})`;
  if (ratio === 0.25) return `Negyed pálya (${parts})`;
  return `${selected.length}/${sectionCount} pálya (${parts})`;
};
